import { Component, Vue } from 'vue-property-decorator';

import { MyUpcomingExpeditionsBlockViewModel } from './MyUpcomingExpeditionsModule.types';
import { getComponentProps } from '@/utils/vueUtils';
import { format } from 'date-fns';
const MyUpcomingExpeditionsModuleProps = Vue.extend({
  props: getComponentProps<MyUpcomingExpeditionsBlockViewModel>({
    Expeditions: [
      {
        Name: "Explore Alaska's coastal wilderness",
        Date: [new Date(2020, 1, 1)],
        Link: '#',
      },
      {
        Name: 'Passage through Egypt',
        Date: [new Date(2020, 1, 1), new Date(2020, 2, 1), new Date(2020, 3, 1)],
        Link: '#',
      },
      {
        Name: 'Vietnam and Cambodia: Along Mekong River, including Angkor and Saigon',
        Date: [new Date(2020, 4, 1)],
        Link: '#',
      },
    ],
  }),
});
@Component({
  components: {},
})
export default class MyUpcomingExpeditionsModule extends MyUpcomingExpeditionsModuleProps {
  convertDate(date: Date): string {
    var dateValue = new Date(date);
    return format(dateValue, 'MMM d yyyy');
  }
}
